import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components/macro'
import { ifProp, withProp } from 'styled-tools'
import { rem } from '../../utils/styles'

const size = ifProp('size', withProp('size', rem), rem(32))

export const StyledIcon = styled.svg.attrs({
  viewBox: '0 0 32 32'
})`
  width: ${size};
  height: ${size};
`

function BaseIcon({ title, children, ...props }) {
  return (
    <StyledIcon {...props}>
      {title && <title>{title}</title>}
      {children}
    </StyledIcon>
  )
}

BaseIcon.propTypes = {
  title: PropTypes.node,
  children: PropTypes.node
}

export default BaseIcon
